module.exports = __webpack_public_path__ + "img/img14.4af9ccf2.jpg";